<template>
  <div
    class="vb-audio"
    :draggable="draggable"
    :class="{ selected: selectedPath == path }"
    @click.stop="$emit('select', path)"
    @dragstart.stop="$emit('toDrag', path)"
    @dragover.stop="$event.preventDefault()"
    @drop.stop="$emit('toDrop', path)"
  >
    <button type="button" name="button" class="vb-audio-player" @click="toogle">
      <div class="vb-audio-player-btn">
        <div class="vb-audio-player-btn-img">
          <font-awesome-icon icon="play" color="#4c6a00" v-if="!playing"/>
          <font-awesome-icon icon="pause" color="#4c6a00" v-else/>
        </div>
        <div class="vb-audio-player-btn-text">
          <strong>Play Listening</strong>
        </div>
        <audio
          ref="vb-audio-player"
          :src="data.src"
          v-show="false"
          @loadeddata="setAudioData"
          @play="playing = true"
          @pause="playing = false"
          @timeupdate="currentTime = $event.target.currentTime"
        />
      </div>
    </button>
    <div class="vb-audio-status">
      <div
        class="vb-audio-status-progress"
        :style="{ width: `calc(${(currentTime * 100) / duration}% - 20px)` }"
      >
        <div class="vb-audio-status-progress-box">
          <div class="vb-audio-status-progress-box-dot">
          </div>
        </div>
      </div>
      <div class="vb-audio-status-bar">
      </div>
    </div>
    <div class="vb-audio-description">
      Listening correspondente ao tópico.
    </div>
  </div>
</template>
<script>
  export default {
    name: 'vb-audio',
    props: {
      data: {
        required: true
      },
      path: {
        required: true
      },
      draggable: {
        type: Boolean
      },
      selectedPath: {
        type: String
      }
    },
    data () {
      return {
        canplay: false,
        playing: false,
        duration: 0,
        currentTime: 0
      }
    },
    methods: {
      setAudioData (event) {
        this.canplay = true
        this.playing = false
        this.duration = event.target.duration
        this.currentTime = event.target.currentTime
      },
      toogle () {
        if (this.data.src && this.canplay) {
          if (this.$refs['vb-audio-player'].paused)
            this.$refs['vb-audio-player'].play()
          else
            this.$refs['vb-audio-player'].pause()
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .vb-audio {
    display: flex;
    flex-direction: row;
    width: 100%;

    &.selected {
      border: .2rem dashed red;
    }

    &-player {
      background: #c9ec73;
      border: none;
      border-radius: 25px;
      padding: 5px 10px;
      width: 150px;

      &-btn {
        display: flex;

        &-img {
          img {
            width: 30px;
            height: 30px;
          }
        }
        &-text {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-grow: 1;
          color: #5d9110;
        }
      }
    }

    &-status {
      position: relative;
      display: flex;
      align-items: center;
      flex-grow: 1;
      margin-left: 10px;
      background: #c9ec73;
      border-radius: 25px;
      border: none;
      padding: 0 10px;

      &-progress {
        position: absolute;
        display: flex;
        justify-content: flex-end;
        z-index: 10;
        background-color: #699401;
        height: 5px;
        border-radius: 25px;

        &-box {
          position: relative;

          &-dot {
            position: absolute;
            right: -5px;
            top: -2px;
            width: 10px;
            height: 10px;
            background: #699401;
            border-radius: 10px;
          }
        }
      }

      &-bar {
        position: absolute;
        z-index: 0;
        border-radius: 25px;
        width: calc(100% - 20px);
        background: #e3ffba;
        height: 5px;
      }
    }

    &-description {
      width: 280px;
      margin-left: 10px;
      font-size: 13px;
      // font-size: clamp(0em, 0.2em + 1vw, 1em);
      border: 1px solid #8ac326;
      border-radius: 25px;
      padding: 5px 5px 5px 25px;
      background: #e3ffba;
      display: flex;
      align-items: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/VirtualBookViewer/VirtualBookAudio.vue